import axiosInstance from "services/AxiosInstance";
import { TAnalyticsFilters } from "types";

export const getAnalyticsGroupedListService = async (payload: TAnalyticsFilters) => {
  const { accountId, ...params } = payload;
  const response = await axiosInstance.get(`/analytics/${accountId}/grouped`, { params });
  return response.data;
};
